<template>
  <div class="virtual-keyboard">
    <div class="keyboard-button"
         @click="selectButton(button)"
         v-for="(button, index) in keyboardButtons"
         :key="index">
      <span v-if="button || button === 0">{{ button }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VirtualKeyboard',
  data() {
    return {
      keyboardButtons: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '.', ''],
    };
  },
  methods: {
    selectButton(button) {
      this.$emit('keyboardButton', button);
    },
  },
};
</script>

<style lang="scss">
  .virtual-keyboard {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .keyboard-button {
      flex-basis: 96px;
      font-size: 14px;
      font-weight: 500;
      padding: 11px 0;

      span {
        padding: 11px 40px;
      }
    }
  }
</style>
